import { QueryClient } from '@tanstack/react-query'
import { settingsQuery, type Settings } from './user'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // TMDB and the iziplay services are not chatty enough to be worth
      // refetching on every window focus, and the lists are paginated.
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
      retry: 1
    }
  }
})

/*
 * Settings read outside of a component -- from the HLS player, which is still a
 * class, and from event handlers. The shell does not wait for them, so this
 * joins its in-flight request rather than reading a cold cache.
 */
export function loadSettings(): Promise<Settings> {
  return queryClient.ensureQueryData(settingsQuery)
}
